// src/utils/clickTracking.js
//
// Posts to the same generic click-tracking endpoint the mobile apps already
// use (POST /clicks -> user_clicks table, see the admin "Clicks" analytics
// page for referrer/OS/route/query breakdowns). The web app never called
// this before, so every page visit and route change here now sends one hit,
// giving the full page-by-page journey alongside the mobile data.
//
// document.referrer stays the same original external source for the whole
// session (SPA navigation doesn't change it) - that's intentional, it's what
// ties every route in one visit back to the channel that brought them in.

import APICall from "../features/APICall";

export const trackClick = (route) => {
  if (typeof window === "undefined") return;

  APICall(
    "clicks",
    "POST",
    {
      referrer: document.referrer || "direct",
      os: navigator.userAgent,
      route,
      query: window.location.search,
    },
    false,
    undefined,
    true // silent - best-effort background ping, never surface a toast for it
  ).catch(() => {});
};
